import { CheckCircle } from 'lucide-react';
import { styled } from 'styled-components'


const OutcomeSection = ( {content}) => {

    return(
        <Container>
            <p style={{ fontSize: '1.125rem', marginBottom: '1rem' }}>Upon completion of this winter school, participants will be able to:</p>
            { content.map((data) => (
                <OutcomeCard>
                    <IconWrapper $bg="#dbeafe">
                    <CheckCircle size={20} color="#2563eb" />
                    </IconWrapper>
                    <OutcomeContent>
                    <OutcomeTitle>{data.title}</OutcomeTitle>
                    <OutcomeText>{data.text}</OutcomeText>
                    </OutcomeContent>
                </OutcomeCard>
            ))}
        </Container>
    )
}

const Container = styled.div``

const OutcomeCard = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  padding: 0.85rem 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  border-left: 3px solid #2563eb;

  &:hover {
    background: #f9fafb;
  }
`;

const IconWrapper = styled.div`
  background: ${props => props.$bg || '#dbeafe'};
  border-radius: 9999px;
  padding: 0.5rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
`;

const OutcomeContent = styled.div`
  flex: 1;
`;

const OutcomeTitle = styled.h4`
  font-weight: 600;
  margin-bottom: 0.3rem;
  color: #111827;
  font-size: 1.05rem;
`;

const OutcomeText = styled.p`
  text-align: justify;
  color: #4b5563;
  font-weight: 300;
  line-height: 1.55;
  font-size: 0.85rem;
`;


export default OutcomeSection;